export default {
  en: {
    title: 'Agents',
    subtitle: 'List of agents or executives who serve clients.',
    columns: {
      name: 'Full Name',
      departments: 'Departments',
      email: 'Email',
    },
    form: {
      firstname: {
        error: 'Please fill the first name of agent.',
        help: 'This is the first name of agent.',
      },
      lastname: {
        error: 'Please fill the last name of agent.',
        help: 'This is the last name of agent.',
      },
      email: {
        error: 'Please fill the email of agent.',
        help: 'Enter the email or username that your agent will access, remember that a username (not email) will not be able to recover the password by mail link.',
      },
      password: {
        error: 'The password must be at least 6 characters.',
        help: 'If you don\'t set a password, we send a link to email for change the password. ¡Remember use a valid email!',
        create: 'Create a password',
      },
      departments: {
        error: '',
        help: 'Select the departments in which the agents will attend.',
      },
      privilege: {
        error: 'Select a privilege for the agent.',
        help: 'This define the permissions of agent. Can be default or customized.',
      },
      passwordConfirm: {
        error: 'The passwords does not match.',
      },
    },
    notification: {
      success: {
        patch: 'The agent {email} was edited successful.',
        post: 'The agent {email} was created successful | The {email} was created successful, we send email for set activate account.',
      },
      fail: {
        conflict: 'The email or username is already used, please choose another.',
        username: 'If you don\'t set a password provide a valid email.\n\n On the contrary case please provide a password and username.',
      },
      permissions: 'Your don\'t have permissions to {action} agents. If you believe this is wrong try again or contact us.',
    },
  },
  es: {
    title: 'Agentes',
    subtitle: 'Lista de agentes o ejecutivos que atienden a sus clientes.',
    columns: {
      name: 'Nombre',
      departments: 'Departamentos',
      email: 'Correo electrónico',
    },
    form: {
      firstname: {
        error: 'Por favor llene el nombre del agente.',
        help: 'Este es el primer nombre del agente.',
      },
      lastname: {
        error: 'Por favor llene el apellido del agente.',
        help: 'Este es el apellido del agente.',
      },
      email: {
        error: 'Por favor complete el correo electrónico del agente.',
        help: 'Ingrese el correo electrónico o nombre de usuario con el que accederá su agente, recuerde que un nombre de usuario (no email) no podrá recuperar la contraseña por correo electrónico.',
      },
      password: {
        error: 'La contraseña debe ser de al menos 6 caracteres.',
        help: 'Si no establece una contraseña, le enviaremos un enlace por correo electrónico para cambiar la contraseña. ¡Recuerda usar un correo electrónico válido!',
        create: 'Crear una contraseña',
      },
      departments: {
        error: '',
        help: 'Seleccione los departamentos a los que pertenecerá el agente.',
      },
      privilege: {
        error: 'Seleccione un privilegio para el agente.',
        help: 'Esto define los permisos del agente. Puede ser predeterminado o personalizado.',
      },
      passwordConfirm: {
        error: 'Las contraseñas no coinciden.',
      },
    },
    notification: {
      success: {
        patch: 'El agente {email} fue editado exitosamente.',
        post: 'El agente {email} fue creado exitosamente. | El agente {email} fue creado exitosamente, le hemos enviado un correo para la activación.',
      },
      fail: {
        conflict: 'El correo electrónico o nombre de usuario ya está en uso, elija otro.',
        username: 'Si no establece una contraseña, proporcione un correo electrónico válido.\n\n Por el contrario, proporcione una contraseña y nombre de usuario.',
      },
      permissions: 'No tienes permisos para {action} agentes. Si crees que esto está mal, intente nuevamente o contáctenos.',
    },
  },
};
